import React from 'react'
import useBlogBink from '../useBlogBink'

interface BlogBinkButtonProps {
  increment?: boolean
  children: any
  className?: string
}

export const BlogBinkButton: React.FC<BlogBinkButtonProps> = ({
  className,
  children,
  increment = true,
}) => {
  const blogBink = useBlogBink()

  return (
    <button
      className={`${className} blog-bink-button`}
      type="button"
      onClick={() => {
        if (increment) {
          blogBink.incrementOffset()
        } else {
          blogBink.decrementOffset()
        }
      }}
      tabIndex={0}
    >
      {children}
    </button>
  )
}

export default BlogBinkButton
